import React from "react";
import videoBg from "../assets/videoBg.mp4";
import Button from "./Button";
import Icons from "./Icons";
import "./Main.css";

export default function Main1() {
  return (
    <div className="main">
      <video src={videoBg} autoPlay loop muted />
      <div className="content">
        <div className="overlay">
          <h1>Felix Martono</h1>
          <p>Lighting Artist</p>
          <Button />
          <Icons />
        </div>
        <footer>
          Coded by{" "}
          <a
            href="https://www.linkedin.com/in/gabriellakarsten/"
            target="_blank"
            rel="noreferrer"
          >
            Gabriella Karsten
          </a>
        </footer>
      </div>
    </div>
  );
}
